import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  message: {
    backgroundColor: '$colorBgSurface',
    paddingVertical: '$space3',
    paddingHorizontal: '$space4',
    borderBottomRightRadius: '$space4',
    borderTopRightRadius: '$space4',
    borderBottomLeftRadius: '$space4',
    width: '100%',
  },
  loading: {
    paddingHorizontal: '$space4',
    paddingVertical: '$space3',
    width: '100%',
  },
});
